import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default function whatWeDo() {
    const section = document.querySelector('[data-name="what-we-do"]')

    if (!section) return

    // const previousSection = section.previousElementSibling // to use if we need to animate the cards before reaching the start trigger
    const nextSection = section.nextElementSibling // to add negative margin for overlap

    const container = section.querySelector('.container')
    const grid = section.querySelector('[data-name="what-we-do-items"]')
    const items = grid.children

    const lastCard = items[0].children[items[0].children.length - 1]
    const firstCard = items[1].children[0]
    const lastCardHeight = lastCard.offsetHeight
    const firstCardHeight = firstCard.offsetHeight

    const whatWeDoText = section.querySelector('[data-name="what-we-do-text"]')

    const mm = gsap.matchMedia()

    mm.add('(min-width: 1025px)', () => {
        gsap.set(items[0], { y: window.innerHeight })
        gsap.set(items[1], { y: -items[1].offsetHeight })
        gsap.set(nextSection, {
            marginTop: -nextSection.offsetHeight * 1.6,
        })

        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: section, // we can use previousSection for better control
                pin: container,
                start: 'top 25%',
                // end: '+=500%',
                endTrigger: nextSection, // can use the commented end above, but more control this way
                end: '+=250% top',
                scrub: 1,
                // markers: true,
            },
        })

        tl.addLabel('start')

        tl.to(
            items[0],
            {
                y: -items[0].offsetHeight + lastCardHeight * 1.5,
                duration: 10,
            },
            'start'
        )
            .to(
                items[1],
                {
                    y:
                        items[1].offsetHeight -
                        window.innerHeight -
                        firstCardHeight * 2,
                    duration: 10,
                },
                'start'
            )
            .to(
                container,
                {
                    rotate: -8,
                    opacity: 0,
                    duration: 7,
                },
                '>-0.25'
            )
            .to(
                whatWeDoText,
                {
                    translateY: '0%',
                    duration: 1,
                },
                'start'
            )
    })
}
